import { useEffect, type ReactNode } from 'react'
import { brandingCssVars } from '@mavatech/theme'
import { trpc } from '@/lib/trpc'

/**
 * Lädt die Marken-/Themedaten des aktiven Mandanten und setzt die
 * überschriebenen CSS-Variablen (z. B. Akzentfarbe) auf <html>.
 * Kein Farbwert im Code — alles kommt aus organization_branding.
 */
export function BrandingProvider({ children }: { children: ReactNode }) {
  const { data } = trpc.branding.get.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  useEffect(() => {
    if (!data) return
    const vars = brandingCssVars({
      accentColor: data.accentColor,
      accentHoverColor: data.accentHoverColor,
    })
    const root = document.documentElement
    for (const [k, v] of Object.entries(vars)) root.style.setProperty(k, v)
    if (data.organization?.legalName) {
      document.title = `${data.organization.legalName} · CRM`
    }
  }, [data])

  return <>{children}</>
}
